import { useState } from "react";
import { useTranslation } from "react-i18next";
import { FileSpreadsheet, Printer } from "lucide-react";
import { toast } from "sonner";
import { downloadReport } from "../../api/payroll";
import { NeuButton } from "../../components/neu/Neu";
import { NEU_3D as BTN_3D } from "../../components/neu/NeuPicker";

const PDF = "bg-red-600 text-white hover:bg-red-700";
const XLSX = "bg-[#217346] text-white hover:bg-[#1a5c38]";
const WIDE = "min-w-[104px] px-8 py-3 font-black flex items-center justify-center gap-2";

export const EXPORT_TARGETS = {
  salary: { path: "/payroll/report/export", name: "payroll", testid: "export-payroll" },
  attendance: { path: "/attendance/report/export", name: "attendance", testid: "export-attendance" },
};

// PDF يفتح التقرير المطبوع (وفيه أزرار تحميل/مشاركة PDF)، و Excel يُنزّل الجدول.
export const ExportButtons = ({ filters, path, name, testid, onPdf, disabled = false }) => {
  const { t, i18n } = useTranslation();
  const [busy, setBusy] = useState("");
  const custom = Boolean(filters.start && filters.end);

  const pull = async (kind) => {
    setBusy(kind);
    try {
      if (kind === "pdf" && onPdf) {
        await onPdf();
        return;
      }
      await downloadReport(path, {
        lang: i18n.language,
        kind,
        ...(custom ? { start: filters.start, end: filters.end } : { month: filters.month }),
        ...(filters.branch_id && filters.branch_id !== "all" ? { branch_id: filters.branch_id } : {}),
        ...(filters.user_id && filters.user_id !== "all" ? { user_id: filters.user_id } : {}),
      }, `${name}-${custom ? `${filters.start}_${filters.end}` : filters.month}.${kind}`);
    } catch {
      toast.error(t("errors.generic"));
    } finally {
      setBusy("");
    }
  };

  return (
    <div className="flex gap-4">
      <NeuButton className={`${WIDE} ${XLSX}`} style={BTN_3D} data-testid={`${testid}-xlsx`}
                 disabled={disabled || busy === "xlsx"} onClick={() => pull("xlsx")}>
        <FileSpreadsheet className="h-5 w-5" /> <span className="text-base">Excel</span>
      </NeuButton>
      <NeuButton className={`${WIDE} ${PDF}`} style={BTN_3D} data-testid={`${testid}-pdf`}
                 disabled={disabled || busy === "pdf"} onClick={() => pull("pdf")}>
        <Printer className="h-5 w-5" /> <span className="text-base">PDF</span>
      </NeuButton>
    </div>
  );
};
